import { Box, SxProps, SvgIconProps } from '@mui/material'
import BesseggenLogo from '../../assets/icons/BesseggenLogo'
import PaperTradingLogo from '../../assets/icons/PaperTradingLogo'
import { BrokerId, isBesseggenBrokerCode, isPaperBrokerCode } from '../../util/tradingAccounts'

export type BrokerIconProps = {
    brokerCode?: string
    imageUrl?: string
    sx?: SxProps
} & Omit<SvgIconProps, 'sx'>

const BrokerIcon = ({ brokerCode, imageUrl, sx, fontSize, ...svgProps }: BrokerIconProps) => {
    if (!brokerCode) {
        return null
    }

    const iconSx = {
        flexShrink: 0,
        display: 'block',
        ...sx
    }

    if (isPaperBrokerCode(brokerCode)) {
        return <PaperTradingLogo sx={iconSx} fontSize={fontSize} {...svgProps} />
    }

    if (isBesseggenBrokerCode(brokerCode)) {
        return <BesseggenLogo sx={iconSx} fontSize={fontSize} {...svgProps} />
    }

    return (
        <Box
            component="img"
            sx={{
                height: fontSize ?? '25px',
                width: fontSize ?? '25px',
                flexShrink: 0,
                display: 'block',
                borderRadius: brokerCode === BrokerId.DHAN ? '100%' : '0%',
                ...sx
            }}
            src={imageUrl}
            alt="broker"
        />
    )
}

export default BrokerIcon
